import React from 'react';
import { PageHeaderLoader } from './common/page-header-loader';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

export const OrderPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hideActions hasSubheading />
      <br />
      <br />
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="100%" height="200px" />
      </SkeletonLoaderWrapper>
    </div>
  );
};
